import React, { useEffect, useState, useCallback, useRef } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Thanks() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  const [user, setUser] = useState(null);
  const [membershipPack, setMembershipPack] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const location = useLocation();
  const navigate = useNavigate();
  const { pack, id } = location.state || {}; // Ensure `pack` and `id` are safely accessed

  const prevPack = useRef(null); // Store the previous value of pack

  // Fetch user and membership pack data
  const fetchData = useCallback(async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (token) {
        // Fetch user data
        const userResponse = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(userResponse.data);

        // Fetch membership pack data
        if (id) {
          const packResponse = await axios.get(`${baseUrl}/packs/${id}`);
          setMembershipPack(packResponse.data.pack);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl, id]);

  // Navigate to /membership/felicitation when pack changes and is not null
  // useEffect(() => {
  //   if (pack && prevPack.current !== pack) {
  //     navigate("/membership/felicitation", {
  //       state: {
  //         pack: pack,
  //         id: id,
  //       },
  //     });
  //   }
  //   prevPack.current = pack; // Update the previous value
  // }, [pack, navigate, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) {
    return (
      <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
        <div className="text-center text-xl md:text-3xl font-bold mb-4 md:mb-6">
          <p>Error</p>
        </div>
        <div className="text-center text-base md:text-xl">{error}</div>
      </div>
    );
  }

  return (
    // <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
    <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">

      <div className="text-center text-3xl md:text-4xl font-bold mb-4 md:mb-6">
        <p>
          {t("thank_you.title")}{" "}
          <span className="font-bold">
            {pack} {language === "fr" ? "" : "pack"}
          </span>{" "}

        </p>
      </div>
      <div className="text-start flex flex-col gap-4 md:gap-7 text-base md:text-lg leading-relaxed md:leading-loose">
        <span>
          {t("thank_you.p1")} <span className="font-bold">{pack} </span>
          {language === "fr" ? "" : "pack"} {t("thank_you.application_sent")}
        </span>
        <span>
          <strong>{t("thank_you.next_step")}</strong>
          <br className="hidden md:block" />
          🔹 {t("thank_you.p2")} <br className="hidden md:block" />
          🔹 {t("thank_you.p3")}
          <br className="hidden md:block" />
          🔹 {t("thank_you.p4")}
          <span className="font-bold">{pack} </span>
          {language === "fr" ? "" : "pack"} !
        </span>
      </div>
    </div>
  );

  // if (error) {
  //   return (
  //     <div
  //       className="flex flex-col gap-12 min-h-screen"
  //       style={{
  //         backgroundImage: `url(${images.golf_field})`,
  //         backgroundPosition: "center",
  //         backgroundSize: "cover",
  //         backgroundRepeat: "no-repeat",
  //       }}
  //     >
  //       <Nav />
  //       <div className="flex justify-center mx-16 mb-20">
  //         <div className="flex w-full justify-between items-start">
  //           <Sidebar />
  //           <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-16 gap-8 w-[75%] rounded-3xl py-12">
  //             <div className="text-center text-3xl font-bold mb-6">
  //               <p>Error</p>
  //             </div>
  //             <div className="text-center text-xl">{error}</div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // return (
  //   <div
  //     className="flex flex-col gap-12 min-h-screen"
  //     style={{
  //       backgroundImage: `url(${images.golf_field})`,
  //       backgroundPosition: "center",
  //       backgroundSize: "cover",
  //       backgroundRepeat: "no-repeat",
  //     }}
  //   >
  //     <Nav />
  //     <div className="flex justify-center mx-16 mb-20">
  //       <div className="flex w-full justify-between items-start">
  //         <Sidebar />
  //         <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-16 gap-8 w-[75%] rounded-3xl py-12">
  //           <div className="text-center text-3xl font-bold mb-6">
  //             <p>
  //               Merci d'avoir choisi le Pack <span className="font-bold">{pack}</span> !
  //             </p>
  //           </div>
  //           <div className="text-start flex flex-col gap-7 text-lg leading-loose">
  //             <span>
  //               Votre demande d'adhésion au Pack <span className="font-bold">{pack}</span> a été envoyée avec succès
  //               à l'administration. Vous serez contacté dès que possible pour
  //               finaliser le processus et profiter de tous les avantages
  //               exclusifs offerts par ce pack.
  //             </span>
  //             <span>
  //               <strong>Quelle est la prochaine étape ?</strong>
  //               <br />
  //               🔹 Assurez-vous que les informations fournies lors de votre
  //               demande sont exactes. <br />
  //               🔹 En cas de retard de contact, n’hésitez pas à joindre
  //               l'administration via les canaux officiels. <br />
  //               🔹 Préparez-vous à vivre une expérience exceptionnelle et unique
  //               avec le Pack <span className="font-bold">{pack}</span> !
  //             </span>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}
